// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3zcy2","title":"FrontImage_title__3YXER"};